<template>
  <h3 :class="`${appendedClass} font-bold text-[0.82rem] text-[#000000] sm:text-[1rem] lg:text-[17px] 3xl:text-[18px] capitalize`.trim()">
    {{ title }}
  </h3>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
            required: true
        },
        appendedClass: {
          type: String,
          required: false,
          default: 'mb-3 md:mb-[1.20rem]',
        }
    },
}
</script>

<style>

</style>